module.exports = __webpack_public_path__ + "ad3eff89d4bccab6ab069d571f276ae1.MP3";